import { agregarACola } from "@/utils/promise-queue";

jest.mock("@/bus", () => ({
  $log: {
    info: jest.fn(),
    error: jest.fn()
  }
}));

describe("Promise queue", () => {
  let __cola = [];

  beforeEach(() => {
    __cola = [];
  });

  it("should execute a promise added", () => {
    const mockFn = jest.fn(
      () =>
        new Promise(resolve => {
          resolve("done");
        })
    );
    agregarACola(mockFn);
    expect(mockFn).toHaveBeenCalled();
  });

  it("should catch Error in promise", () => {
    const mockFn = jest.fn().mockRejectedValue(new Error("Error promise"));
    agregarACola(mockFn);
    expect(__cola).toHaveLength(0);
  });
});
